import { render, staticRenderFns } from "./buildingView.vue?vue&type=template&id=e3bb24c0&scoped=true"
import script from "./buildingView.vue?vue&type=script&lang=js"
export * from "./buildingView.vue?vue&type=script&lang=js"
import style0 from "./buildingView.vue?vue&type=style&index=0&id=e3bb24c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3bb24c0",
  null
  
)

export default component.exports